import Modules from '@app/modules';
import CompanyStore from '@app/modules/Racerfish/Company/store';
import { defineAsyncComponent } from 'vue';
Modules.register({
    namespace: 'RF/Company',
    store: CompanyStore,
    blocks: {
        'company.team': defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-Blocks-Company" */ '@app/modules/Racerfish/Company/Blocks/team.vue')),
        'company.jobs': defineAsyncComponent(() => import(/* webpackChunkName: "Evolve-Blocks-Company" */ '@app/modules/Racerfish/Company/Blocks/jobs.vue')),
    }
});
